var map = {
	"./call-to-action/view.js": "./template/blocks/call-to-action/view.js",
	"./care-package/view.js": "./template/blocks/care-package/view.js",
	"./care-steps/view.js": "./template/blocks/care-steps/view.js",
	"./care-why-choose/view.js": "./template/blocks/care-why-choose/view.js",
	"./faq-item/view.js": "./template/blocks/faq-item/view.js",
	"./faq/view.js": "./template/blocks/faq/view.js",
	"./hero-block/view.js": "./template/blocks/hero-block/view.js",
	"./hero-services/view.js": "./template/blocks/hero-services/view.js",
	"./info-icon/view.js": "./template/blocks/info-icon/view.js",
	"./logo-slider/view.js": "./template/blocks/logo-slider/view.js",
	"./post-slider/view.js": "./template/blocks/post-slider/view.js",
	"./realization-features/view.js": "./template/blocks/realization-features/view.js",
	"./realization-hero/view.js": "./template/blocks/realization-hero/view.js",
	"./services-advantages/view.js": "./template/blocks/services-advantages/view.js",
	"./services-boxes-icons/view.js": "./template/blocks/services-boxes-icons/view.js",
	"./services-boxes/view.js": "./template/blocks/services-boxes/view.js",
	"./services-image-text-box/view.js": "./template/blocks/services-image-text-box/view.js",
	"./services-links/view.js": "./template/blocks/services-links/view.js",
	"./services-why-us/view.js": "./template/blocks/services-why-us/view.js",
	"./text-image/view.js": "./template/blocks/text-image/view.js",
	"./toggle-text/view.js": "./template/blocks/toggle-text/view.js",
	"./wrapper-block/view.js": "./template/blocks/wrapper-block/view.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template/blocks sync recursive view\\.js$";